<template>
<v-card outlined tile>
    <v-card-text>
        <v-form ref="form" style="width: 100%" v-model="valid">
            <div class="d-flex align-center flex-wrap">
                <div class="mr-3 mb-1 flex-grow-1 flex-sm-grow-0">
                    <DateRangeInput v-model="fields.daterange" @change="changed('daterange', $event)" label="Rango de Fechas" :disabled="loading"/>
                </div>
                <div class="mr-3 mb-1 flex-grow-1 flex-sm-grow-0">
                    <SelectorJuego
                        :disabled="loading"
                        label="Juego"
                        @change="changed('juego_id', $event)"
                        v-model="fields.juego_id"
                        :autoselect="false"
                        />
                </div>
                <div class="mr-3 mb-1 flex-grow-1 flex-sm-grow-0">
                    <SelectorJuegoSorteo
                        :disabled="loading"
                        label="Sorteo"
                        :params="{juego_id: fields.juego_id}"
                        @change="changed('juego_sorteo_id', $event)"
                        v-model="fields.juego_sorteo_id"
                        :autoselect="false"
                        />
                </div>
            </div>
        </v-form>
    </v-card-text>
    <v-divider/>
    <v-card-actions class="d-flex align-center flex-wrap">
        <v-spacer/>
        <div class="d-flex">
            <v-btn text class="mr-2" :disabled="loading" @click="reset()" small>Reiniciar Filtros</v-btn>
            <v-btn color="primary" tile :disabled="loading" :loading="loading" @click="search()" small elevation="0"><v-icon>mdi-magnify</v-icon>Buscar</v-btn>
        </div>
    </v-card-actions>
</v-card>
    
</template>

<script>
import Search from '@mixins/search';

export default {
    props: {
        value: {},
        loading: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [Search],
    data: function ()  {
        return {
            defaultFields: {
                daterange: [this.$luxon.local().toISODate(), this.$luxon.local().toISODate()],

                juego_id: null,
                juego_sorteo_id: null,
            },
        }
    },
}
</script>

<style>

</style>